import { render, staticRenderFns } from "./LibraryCategoriesMenu.vue?vue&type=template&id=2c21f88f&lang=pug&"
import script from "./LibraryCategoriesMenu.vue?vue&type=script&lang=js&"
export * from "./LibraryCategoriesMenu.vue?vue&type=script&lang=js&"
import style0 from "./LibraryCategoriesMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports